import internalChatChannelsAPI from 'dashboard/api/internalChatChannels';

const state = {
  results: { channels: [], dms: [], messages: [] },
  isLimited: false,
  uiFlags: { isSearching: false },
};

const getters = {
  getChannels: s => s.results.channels,
  getDMs: s => s.results.dms,
  getMessages: s => s.results.messages,
  getUIFlags: s => s.uiFlags,
  isSearchLimited: s => s.isLimited,
};

const mutations = {
  SET_UI_FLAGS(s, flags) {
    s.uiFlags = { ...s.uiFlags, ...flags };
  },
  SET_RESULTS(s, { channels = [], dms = [], messages = [], isLimited = false }) {
    s.results = { channels, dms, messages };
    s.isLimited = isLimited;
  },
  CLEAR_RESULTS(s) {
    s.results = { channels: [], dms: [], messages: [] };
    s.isLimited = false;
  },
};

const actions = {
  async search({ commit }, { query, page } = {}) {
    if (!query || query.length < 3) return;
    commit('SET_UI_FLAGS', { isSearching: true });
    try {
      const { data } = await internalChatChannelsAPI.search({ q: query, page });
      const payload = data?.data || data || {};
      commit('SET_RESULTS', {
        channels: payload.channels || [],
        dms: payload.dms || [],
        messages: payload.messages || [],
        isLimited: payload.is_limited || false,
      });
    } finally {
      commit('SET_UI_FLAGS', { isSearching: false });
    }
  },

  clearSearch({ commit }) {
    commit('CLEAR_RESULTS');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
